import React from "react";

const LABELS = {
  new_lead: "New Lead",
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  invoiced: "Invoiced",
  paid: "Paid",
  unpaid: "Unpaid",
};

export default function StatusPill({ status, className = "" }) {
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium border status-${status} ${className}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
